import { create } from 'zustand';

function loadStoredUser() {
  try {
    const raw = localStorage.getItem('aic_user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export const useAuthStore = create((set) => ({
  token: localStorage.getItem('aic_token') || null,
  user: loadStoredUser(),

  setAuth: (token, user) => {
    localStorage.setItem('aic_token', token);
    localStorage.setItem('aic_user', JSON.stringify(user || null));
    set({ token, user });
  },

  logout: () => {
    localStorage.removeItem('aic_token');
    localStorage.removeItem('aic_user');
    set({ token: null, user: null });
  },
}));
